import Swal from 'sweetalert2/dist/sweetalert2.js'

const checkWishlist = (checked) => {
    let $wishlistCounter = document.querySelectorAll('.wishlist-counter');
    let $wishlistTriggers = document.querySelectorAll('.wishlist-trigger');
    let $wishlistTooltip = document.getElementById('wishlist-tooltip');
    if ($wishlistTooltip === null) return;
    let wishlistExpiredTxt = $wishlistTooltip.dataset.expired;
    let wishlistSoonTxt = $wishlistTooltip.dataset.soon;
    if ($wishlistTooltip) {
        let $closeButton = $wishlistTooltip.querySelector('.close-button');
    }

    if (localStorage.hasOwnProperty('wishlist')) {
        let showIds = JSON.parse(localStorage.wishlist);
        $wishlistCounter.forEach((counter) => {
            counter.textContent = showIds.length;
        });
        $wishlistTriggers.forEach((trigger) => {
            if (showIds.length) {
                trigger.classList.add('is-active');
            } else {
                trigger.classList.remove('is-active');
            }
        });
        let today = new Date();
        let soon = new Date();
        soon = soon.setDate(soon.getDate() + 3);
        let warningTxt = '';
        showIds.forEach((value) => {
            let $event = document.querySelectorAll('.wishlist-' +value.id);
            $event.forEach(evt => {
                evt.classList.add('is-active');
                evt.title = evt.dataset.remove;
            });
            if (!checked) {
                let showDate = Date.parse(value.info.datetime);
                if (Date.parse(today) > showDate) {
                    warningTxt += '<span><b>' + value.info.title + '</b><br><i>' + value.info.subtitle + '</i><br>' + wishlistExpiredTxt + '</span>';
                    removeWishlistItem(value.id)
                } else if (soon >= showDate) {
                    warningTxt += '<span><b>' + value.info.title + '</b><br><i>' + value.info.subtitle + '</i><br>' + wishlistSoonTxt + '</span>';
                }
            }
        });
        if (sessionStorage.getItem('shown') !== 'true' && !checked && warningTxt !== '') {
            showTooltip(warningTxt, $wishlistTooltip);
            sessionStorage.setItem('shown', 'true');
        }
    } else {
        $wishlistCounter.forEach((counter) => {
            counter.textContent = '0';
        });
        $wishlistTriggers.forEach((trigger) => {
            trigger.classList.remove('is-active');
        });
    }
}

const addWishlistItem = ($obj) => {
    $obj.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        if ($obj.classList.contains('is-active')) {
            Swal.fire({
                scrollbarPadding: false,
                title: wishlistRemoveConfirm,
                html: wishlistRemoveTxt1 + ' <b>'  + $obj.dataset.productiontitle + '</b> - <i>' + $obj.dataset.productionsubtitle + '</i> ' + wishlistRemoveTxt2,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: wishListCancel,
                confirmButtonText: wishlistRemoveTxt1
            }).then((result) => {
                if (result.isConfirmed) {
                    removeWishlistItem($obj.dataset.eventid);
                }
            });
        } else {
            storeWishlistItem($obj);
        }
    });
}

const removeWishlistItem = (id) => {
    if (localStorage.hasOwnProperty('wishlist')) {
        let showIds = JSON.parse(localStorage.wishlist);
        if (showIds.some(el => el.id === id)) {
            let newShowIds = showIds.filter((e) => {
                return e.id != id;
            });
            localStorage.setItem("wishlist", JSON.stringify(newShowIds));
            window.dispatchEvent(new CustomEvent('wishlist-localstorage-changed', {
                detail: {
                    storage: localStorage.getItem('wishlist')
                }
            }));
            let $event = document.querySelectorAll('.wishlist-'+id);
            $event.forEach(evt => {
                evt.classList.remove('is-active');
                evt.title = evt.dataset.add;
            });
            checkWishlist(true);
        }
    }
}

const storeWishlistItem = ($obj) => {
    let today = new Date();
    let id = $obj.dataset.eventid;
    let productionTitle = $obj.dataset.productiontitle;
    let productionSubtitle = $obj.dataset.productionsubtitle;
    let $wishlistTooltip = document.getElementById('wishlist-tooltip');
    let wishlistExpiredTxt = $wishlistTooltip.dataset.expired;
    let datetime = $obj.dataset.datetime;
    let html = '';
    if (Date.parse(today) > Date.parse(datetime)) {
        html = '<b>' + productionTitle + '</b><br><i>' + productionSubtitle + '</i><br><b>' + wishlistExpiredTxt + '</b>';
    } else {
        var showIds = new Array();
        var showInfo = { 'id': '', 'info': { 'title': '', 'subtitle': '', 'datetime': '' } };
        if (localStorage.hasOwnProperty('wishlist')) {
            showIds = JSON.parse(localStorage.wishlist);
        }
        if (!showIds.some(el => el.id === id)) {
            showInfo.id = id;
            showInfo.info.title = productionTitle;
            showInfo.info.subtitle = productionSubtitle;
            showInfo.info.datetime = datetime;
            showIds.push(showInfo);
            $obj.classList.add('is-active');
            $obj.title = $obj.dataset.remove;
        }
        localStorage.setItem("wishlist", JSON.stringify(showIds));
        window.dispatchEvent(new CustomEvent('wishlist-localstorage-changed', {
            detail: {
                storage: localStorage.getItem('wishlist')
            }
        }));
        let $wishlistCounter = document.querySelectorAll('.wishlist-counter');
        $wishlistCounter.forEach((counter) => {
            counter.textContent = showIds.length;
        });
        let $wishlistTriggers = document.querySelectorAll('.wishlist-trigger');
        $wishlistTriggers.forEach((trigger) => {
            trigger.classList.add('is-active');
        });

        html = '<b>' + productionTitle + '</b><br><i>' + productionSubtitle + '</i><br>' + $wishlistTooltip.dataset.addtxt;
    }
    showTooltip(html, $wishlistTooltip, $obj);
}

const showTooltip = (html, $tooltip, $initiator = null) => {
    $tooltip.innerHTML = html;
    $tooltip.classList.remove('is-hidden');
    $tooltip.classList.add('is-active');
    if ($initiator === null) {
        var $closeButton = document.createElement('button');
        $closeButton.className = "delete is-large";
        $tooltip.appendChild($closeButton);
        $closeButton.addEventListener('click', () => {
            $tooltip.classList.remove('is-active');
            setTimeout(() => {
                $tooltip.classList.add('is-hidden');
                $tooltip.innerHTML = '';
            }, 1000);
        });
    } else {
        const boundingRectInitiator = $initiator.getBoundingClientRect();
        const boundingRectTooltip = $tooltip.getBoundingClientRect();
        let calcLeft = boundingRectInitiator.left + boundingRectInitiator.width / 2 - boundingRectTooltip.width + 28 < 0 ? 0 : boundingRectInitiator.left + boundingRectInitiator.width / 2 - boundingRectTooltip.width + 28;
        $tooltip.style.top = boundingRectInitiator.bottom + window.scrollY + 15 + 'px';
        $tooltip.style.left = calcLeft + 'px';
        $tooltip.classList.add('is-initiated');
        $initiator.blur();
        setTimeout(() => {
            $tooltip.classList.remove('is-active');
            setTimeout(() => {
                $tooltip.classList.remove('is-initiated');
                $tooltip.classList.add('is-hidden');
                $tooltip.innerHTML = '';
            }, 1000);
        }, 3000);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    checkWishlist(false);
    const $wishlistAdds = document.querySelectorAll('.wishlist-add:not(.has-text-secondary)');
    $wishlistAdds.forEach(($wishlistAdd) => {
        addWishlistItem($wishlistAdd);
    });
});

export { checkWishlist, removeWishlistItem, storeWishlistItem, addWishlistItem };